import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { ReportsService } from '../reports.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { UserTrans } from '../userTrans.model';
import { Users } from 'src/app/options/users/users.model';
import { OptionService } from 'src/app/options/option.service';
import { LocalStorageService } from 'ngx-webstorage';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-usertrans',
  templateUrl: './usertrans.component.html',
  styleUrls: ['./usertrans.component.css']
})
export class UsertransComponent implements OnInit {

  reports: UserTrans[] = [];
  users: Users[] = [];
  displayedColumns: string[] = ['date', 'transType', 'amount', 'createBy', 'prevBalance', 'currBalance'];
  dataSource!: MatTableDataSource<UserTrans>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;

  selectedTransType: number = 0;
  spinnerOverlay = false;
  selectedUser!: string;
  lang = 'en';
  reportObj: UserTrans = {} as UserTrans;
  pageSize = 100;
  filteredOptions!: Observable<any[]>;
  userControl = new FormControl();

  constructor(private service: ReportsService,
    private optionService: OptionService,
    private globle: Globle,
    private localStorage: LocalStorageService) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getUsers();
  }

  getUsers() {
    this.spinnerOverlay = true;
    let userId = this.localStorage.retrieve("userInfo").userId
    this.optionService.getAllCustomers(userId).subscribe(data => {
      this.users = data
      this.autoCompleatFilter();
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  displayFn(user: Users): string {
    return user && user.userName || user.fullName ? user.userName || user.fullName : '';
  }

  autoCompleatFilter() {

    this.filteredOptions = this.userControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.users.slice())
      );
  }

  private _filter(name: string): Users[] {
    const filterValue = name.toLowerCase();

    return this.users.filter(option => option.userName.indexOf(filterValue) === 0 || option.fullName.toLowerCase().indexOf(filterValue) === 0);
  }

  selectUsersChange(value: any) {
    this.selectedUser = value.id;
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getUserTrans(this.selectedUser, this.fromDate.nativeElement.value,
      this.toDate.nativeElement.value, this.selectedTransType).subscribe(data => {
        this.reports = data;

        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      },
        error => {
          this.spinnerOverlay = false;
          console.log(error);
          this.reports = [];
          this.dataSource = new MatTableDataSource(this.reports);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
  }

  onApply() {
    this.get();
  }

  getTotalDeposit() {
    return this.reports.filter(x => x.transType == 1 && x.operationBuyType == 0).map(t => t.amount).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف حركات مستخدم ", 90, 10);
    doc.text("_________________________________", 50, 12);

    // set font
    doc.setFontSize(10);
    doc.viewerPreferences({ "Direction": "L2R" }, true);

    let userName = this.users.find(x => x.id == this.selectedUser)?.fullName != null ?
      this.users.find(x => x.id == this.selectedUser)?.fullName :
      this.users.find(x => x.id == this.selectedUser)?.userName;

    doc.text(" المستخدم : " + userName, 150, 20, {
      isOutputRtl: true,
    });

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#userTransTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }
}
